import CancelPresentationIcon from '@mui/icons-material/CancelPresentation'
import {Backdrop, FormControl, MenuItem, Modal, Select} from '@mui/material'
import Box from '@mui/material/Box'
import {DataGridPro} from '@mui/x-data-grid-pro'
import {envBackHost} from 'GLOBAL/envVariables'
import {axiosWithAuth} from 'helper/axiosWithAuth'
import {customerInfoCorrectColumns} from 'pages/customer/dataConfig/declearColumns'
import {customerInfoCorrectFilter} from 'pages/customer/dataConfig/declearFilters'
import {
  customerInfoCorrectResultRows,
  customerInfoCorrectRows,
  customerRemoveResultRows,
} from 'pages/customer/dataConfig/declearRows'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getCustomerList} from 'utils/apiCalling/api'
import {confirmAlert, normalAlert, resultAlert} from 'utils/CustomAlert/Alert'
import useMobileBackClose from 'utils/hooks/useMobileBackClose'
import './print.css'

const CorrectModal = (props: any) => {
  /*********************************************************************
   * 1. Init Libs
   *********************************************************************/
  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    height: '96%',
    bgcolor: 'background.paper',
    overflowY: 'auto',
    borderRadius: '12px',
    boxShadow: 24,
    py: 2,
    px: 4,
  }
  const dataGridStyle = 'h-[240px] py-2'
  const baseStyle = 'px-4 py-1 rounded-full text-lg font-bold cursor-pointer transition h-10'
  const selectedStyle = 'bg-lime-500 text-white border-transparent'
  const unselectedStyle = 'bg-white text-gray-800 border border-gray-300 hover:bg-gray-100'

  const resultListInit = [{}, {}]
  const resultRemoveInit = [{}]

  /*********************************************************************
   * 2. State settings
   *********************************************************************/
  const {open, onClose, callBack} = props
  useMobileBackClose(open, onClose)
  const officeInfo = useSelector((state: any) => state?.officeInfo)
  const cooperInfo = useSelector((state: any) => state?.cooperInfo)
  const [selectedType, setSelectedType] = useState<string>('device')
  const [step, setStep] = useState<number>(1)
  const [firstFilter, setFirstFilter] = useState<any>(customerInfoCorrectFilter())
  const [secondFilter, setSecondFilter] = useState<any>(customerInfoCorrectFilter())
  const [firstLoading, setFirstLoading] = useState<boolean>(false)
  const [secondLoading, setSecondLoading] = useState<boolean>(false)
  const [firstCustomerList, setFirstCustomerList] = useState<any>(null)
  const [secondCustomerList, setSecondCustomerList] = useState<any>(null)
  const [selectedList, setSelectedList] = useState<any>(resultListInit)
  const [selectedRemoveList, setSelectedRemoveList] = useState<any>(resultRemoveInit)
  const [swappedResultList, setSwappedResultList] = useState<any>([])
  const [newCustomerNumber, setNewCustomerNumber] = useState<any>('')
  const [connectStatus, setConnectStatus] = useState<any>('true')

  const columns: any = (state: any) => {
    return customerInfoCorrectColumns(
      cooperInfo,
      connectStatus,
      state,
      selectedType,
      newCustomerNumber
    )
  }
  const firstRows = customerInfoCorrectRows(firstCustomerList)
  const secondRows = customerInfoCorrectRows(secondCustomerList)
  const resultsRows = customerInfoCorrectResultRows(swappedResultList)
  const removeResultsRows = customerRemoveResultRows(selectedRemoveList)
  /*********************************************************************
   * 3. Handlers
   *********************************************************************/
  const resetHandler = () => {
    setFirstFilter(customerInfoCorrectFilter())
    setSecondFilter(customerInfoCorrectFilter())
    setFirstCustomerList(null)
    setSecondCustomerList(null)
    setSelectedList(resultListInit)
    setSwappedResultList([])
    setSelectedRemoveList(resultRemoveInit)
    setConnectStatus('true')
    setNewCustomerNumber('')
    setStep(1)
  }

  const explainMessageHandler = (selectedType: string) => {
    switch (selectedType) {
      case 'device':
        return (
          <span className='text-[1.5rem]'>
            두 수용가 간의 <strong>단말기</strong>를 서로 변경하는 기능입니다.
          </span>
        )
      case 'customer':
        return (
          <span className='text-[1.5rem]'>
            <strong>수용가 번호</strong>를 변경하는 기능입니다.
          </span>
        )
      case 'remove':
        return (
          <span className='text-[1.5rem]'>
            해당 수용가를 <strong>철거</strong> 상태로 변경하는 기능입니다.
          </span>
        )
      case 'disused':
        return (
          <span className='text-[1.5rem]'>
            해당 수용가를 <strong>폐전</strong> 상태로 변경하는 기능입니다.
          </span>
        )

      default:
        return <></>
    }
  }

  const updateCorrectHandler = async (selectedType: string) => {
    if (await confirmAlert('변경', 'info')) {
      switch (selectedType) {
        case 'device':
          try {
            const res = await axiosWithAuth().patch(`${envBackHost}/device/swap`, {
              customerA: selectedList[0]?.customerNumber,
              officeA: officeInfo?.value,
              imeiA: selectedList[0]?.imei,
              customerB: selectedList[1]?.customerNumber,
              officeB: officeInfo?.value,
              imeiB: selectedList[1]?.imei,
            })

            if (res.data.resultCode === 0) {
              await resultAlert(res.data)
              callBack()
              resetHandler()
            } else {
              await resultAlert(res.data, res.data.message)
            }
          } catch (error) {
            await resultAlert({resultCode: 500})
            return
          } finally {
          }
          break
        case 'customer':
          try {
            const res = await axiosWithAuth().patch(`${envBackHost}/customer/number`, {
              officeId: selectedRemoveList[0]?.officeId,
              oldCustomerNumber: selectedRemoveList[0]?.customerNumber,
              newCustomerNumber: newCustomerNumber,
            })

            if (res.data.resultCode === 0) {
              await resultAlert(res.data)
              callBack()
              resetHandler()
            } else {
              await resultAlert(res.data, res.data.message)
            }
          } catch (error) {
            await resultAlert({resultCode: 500})
            return
          } finally {
          }
          break

        case 'remove':
        case 'disused':
          try {
            const res = await axiosWithAuth().delete(`${envBackHost}/customer/destroy`, {
              params: {
                officeId: selectedRemoveList[0]?.officeId,
                cooperIdx: selectedRemoveList[0]?.cooperIdx,
                customerNumber: selectedRemoveList[0]?.customerNumber,
                imei: selectedRemoveList[0]?.imei,
                customerStatus: selectedRemoveList[0]?.customerStatus,
                connectStatus: connectStatus,
              },
            })
            if (res.data.resultCode === 0) {
              await resultAlert(res.data)
              callBack()
              resetHandler()
            } else {
              await resultAlert(res.data, res.data.message)
            }
          } catch (error) {
            await resultAlert({resultCode: 500})
            return
          } finally {
          }
          break

        default:
          return false
      }
    }
  }

  const closeHandler = () => {
    resetHandler()
    setSelectedType('device')
    onClose()
  }

  const ChipSelector = (value: string) => {
    if (selectedType !== value) {
      setSelectedType(value)
      setFirstFilter(customerInfoCorrectFilter())
      setSecondFilter(customerInfoCorrectFilter())
      setFirstCustomerList(null)
      setSecondCustomerList(null)
      setSelectedList(resultListInit)
      setSwappedResultList([])
      setStep(1)
    }
  }

  const swapHandler = (selectedList: any, type: any) => {
    const [first, second] = selectedList
    const swappedFirst = {...first, id: 1}
    const swappedSecond = {...second, id: 2}
    const deviceSwapFields = [
      'filePath',
      'imageIdxDate',
      'serialNumber',
      'revisionPath',
      'temperature',
      'rotate',
      'signalStrength',
      'imei',
      'batteryLevel',
      'checkValue',
      'processStatus',
      'efosConnectAt',
    ]

    const customerSwapFields = ['customerNumber']

    if (type === 'device') {
      deviceSwapFields.forEach((field) => {
        swappedFirst[field] = second?.[field]
        swappedSecond[field] = first?.[field]
      })
    }

    if (type === 'customer') {
      customerSwapFields.forEach((field) => {
        swappedFirst[field] = second?.[field]
        swappedSecond[field] = first?.[field]
      })
    }

    setSwappedResultList([swappedFirst, swappedSecond])
  }

  const onFirstRowClickHandler = async (params: any) => {
    if (params.row.customerNumber === selectedList[1]?.customerNumber) {
      await normalAlert('동일한 수용가는 선택할 수 없습니다.')
      return false
    }
    setSelectedList((prev: any) => {
      const updated = [...prev]
      updated[0] = params.row
      return updated
    })
    if (step === 1) {
      setStep(2)
    }
  }

  const onSecondRowClickHandler = async (params: any) => {
    if (params.row.customerNumber === selectedList[0]?.customerNumber) {
      await normalAlert('동일한 수용가는 선택할 수 없습니다.')
      return false
    }
    setSelectedList((prev: any) => {
      const updated = [...prev]
      updated[1] = params.row
      return updated
    })

    if (step === 2) {
      setStep(3)
    }
  }

  const findFirstCustomerHandler = async () => {
    await getCustomerList(
      officeInfo,
      cooperInfo,
      firstFilter,
      async (res: any, count: any) => {
        setFirstCustomerList(res)
      },
      (error: any) => {},
      () => {
        setFirstLoading(false)
      }
    )
  }
  const findSecondCustomerHandler = async () => {
    await getCustomerList(
      officeInfo,
      cooperInfo,
      secondFilter,
      async (res: any, count: any) => {
        setSecondCustomerList(res)
      },
      (error: any) => {},
      () => {
        setSecondLoading(false)
      }
    )
  }

  const removeFirstRowClickHandler = async (params: any, type: any) => {
    setSelectedRemoveList((prev: any) => {
      const updated = [...prev]
      updated[0] = {...params.row, customerStatus: type}
      return updated
    })
    if (step === 1) {
      setStep(2)
    }
  }
  const buttonTypeHandler = (type: any) => {
    switch (type) {
      case 'device':
        return step === 3 ? true : false
      case 'customer':
        return step === 2 && newCustomerNumber !== '' ? true : false
      case 'remove':
      case 'disused':
        return step === 2 ? true : false

      default:
        return false
    }
  }

  /*********************************************************************
   * 4. UseEffect
   *********************************************************************/

  useEffect(() => {
    swapHandler(selectedList, selectedType)
  }, [selectedList])

  useEffect(() => {
    setConnectStatus('true')
  }, [selectedType])

  /*********************************************************************
   * 5. Page configuration
   *********************************************************************/
  return (
    <Modal
      open={open}
      onClose={() => {
        closeHandler()
      }}
      closeAfterTransition
      slots={{backdrop: Backdrop}}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
      id={'printTarget'}
      className={'printTarget'}
    >
      <Box sx={style}>
        <div className='w-full h-full flex flex-col'>
          <div className='flex-1'>
            <div className={'w-100 d-flex justify-content-between'}>
              <div className='flex gap-4'>
                <div
                  className={`${baseStyle} ${
                    selectedType === 'device' ? selectedStyle : unselectedStyle
                  }`}
                  onClick={() => ChipSelector('device')}
                >
                  단말기 변경
                </div>
                <div
                  className={`${baseStyle} ${
                    selectedType === 'customer' ? selectedStyle : unselectedStyle
                  }`}
                  onClick={() => ChipSelector('customer')}
                >
                  수용가 번호 변경
                </div>

                <div
                  className={`${baseStyle} ${
                    selectedType === 'remove' ? selectedStyle : unselectedStyle
                  }`}
                  onClick={() => ChipSelector('remove')}
                >
                  수용가 철거
                </div>
                <div
                  className={`${baseStyle} ${
                    selectedType === 'disused' ? selectedStyle : unselectedStyle
                  }`}
                  onClick={() => ChipSelector('disused')}
                >
                  수용가 폐전
                </div>
              </div>
              <CancelPresentationIcon
                sx={{fontSize: '40px', cursor: 'pointer'}}
                color={'error'}
                onClick={() => {
                  closeHandler()
                }}
              />
            </div>

            <div>
              {explainMessageHandler(selectedType)}

              {selectedType === 'device' && (
                <>
                  {step > 0 && (
                    <div className='mt-4 border-b-2'>
                      <label className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                        첫번째 수용가 선택
                      </label>
                      <div className='flex items-center gap-2'>
                        <input
                          type='text'
                          value={firstFilter.searchData}
                          onChange={(e) => {
                            setFirstFilter({...firstFilter, searchData: e.target.value})
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              findFirstCustomerHandler()
                            }
                          }}
                          placeholder='검색어를 입력해주세요'
                          className='border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition w-[50%]'
                        />
                        <button
                          type='button'
                          className='bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition'
                          onClick={() => {
                            findFirstCustomerHandler()
                          }}
                        >
                          검색
                        </button>
                      </div>
                      <div className={dataGridStyle}>
                        <DataGridPro
                          rowHeight={160}
                          headerHeight={30}
                          disableColumnMenu
                          hideFooterPagination={true}
                          hideFooter={true}
                          rows={firstRows}
                          columns={columns('first')}
                          onRowClick={(params) => {
                            onFirstRowClickHandler(params)
                          }}
                          // getRowClassName={(params) =>
                          //   params.id === updateData.firstCustomer ? 'bg-blue-100' : ''
                          // }
                          sx={{
                            '& .MuiDataGrid-cell:focus': {
                              outline: 'none',
                            },
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {step > 1 && (
                    <div className='mt-4 border-b-2'>
                      <label className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                        두번째 수용가 선택
                      </label>
                      <div className='flex items-center gap-2'>
                        <input
                          type='text'
                          value={secondFilter.searchData}
                          onChange={(e) =>
                            setSecondFilter({...secondFilter, searchData: e.target.value})
                          }
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              findSecondCustomerHandler()
                            }
                          }}
                          placeholder='검색어를 입력해주세요'
                          className='border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition w-[50%]'
                        />
                        <button
                          type='button'
                          className='bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition'
                          onClick={() => {
                            findSecondCustomerHandler()
                          }}
                        >
                          검색
                        </button>
                      </div>
                      <div className={dataGridStyle}>
                        <DataGridPro
                          rowHeight={160}
                          headerHeight={30}
                          disableColumnMenu
                          hideFooterPagination={true}
                          hideFooter={true}
                          rows={secondRows}
                          columns={columns('second')}
                          onRowClick={(params) => {
                            onSecondRowClickHandler(params)
                          }}
                          // getRowClassName={(params) =>
                          //   params.id === updateData.secondCustomer ? 'bg-blue-100' : ''
                          // }
                          sx={{
                            '& .MuiDataGrid-cell:focus': {
                              outline: 'none',
                            },
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {step > 2 && (
                    <div className='mt-4'>
                      <label className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                        다음과 같이 변경 됩니다.
                      </label>
                      <div className='h-[365px] py-2'>
                        <DataGridPro
                          rowHeight={160}
                          headerHeight={30}
                          disableColumnMenu
                          hideFooterPagination={true}
                          hideFooter={true}
                          rows={resultsRows}
                          columns={columns('list')}
                          sx={{
                            '& .MuiDataGrid-cell:focus': {
                              outline: 'none',
                            },
                          }}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              {(selectedType === 'remove' ||
                selectedType === 'disused' ||
                selectedType === 'customer') && (
                <>
                  {step > 0 && (
                    <div className='mt-4 border-b-2'>
                      <label className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                        수용가 선택
                      </label>
                      <div className='flex items-center gap-2'>
                        <input
                          type='text'
                          value={firstFilter.searchData}
                          onChange={(e) => {
                            setFirstFilter({...firstFilter, searchData: e.target.value})
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              findFirstCustomerHandler()
                            }
                          }}
                          placeholder='검색어를 입력해주세요'
                          className='border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition w-[50%]'
                        />
                        <button
                          type='button'
                          className='bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition'
                          onClick={() => {
                            findFirstCustomerHandler()
                          }}
                        >
                          검색
                        </button>
                        {(selectedType === 'remove' || selectedType === 'disused') && (
                          <>
                            <span className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                              숨김 처리 유무
                            </span>
                            <FormControl className='w-[8rem]' id='connectStatus'>
                              <Select
                                id={'status'}
                                variant='outlined'
                                autoComplete='off'
                                value={connectStatus}
                                onChange={(e) => {
                                  setConnectStatus(e.target.value)
                                }}
                                displayEmpty
                                sx={{
                                  fontSize: '1.5rem',
                                  height: '3rem',
                                  width: '100%',
                                  backgroundColor: 'white',
                                }}
                              >
                                <MenuItem key={1} value={'true'}>
                                  표시
                                </MenuItem>
                                <MenuItem key={2} value={'false'}>
                                  미표시
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        )}
                        {selectedType === 'customer' && (
                          <>
                            <span className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                              변경 수용가 번호 :
                            </span>
                            <input
                              type='text'
                              value={newCustomerNumber}
                              onChange={(e) => {
                                setNewCustomerNumber(e.target.value)
                              }}
                              placeholder='변경할 수용가번호를 입력해주세요'
                              className='border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 transition w-[20rem]'
                            />
                          </>
                        )}
                      </div>

                      <div className={dataGridStyle}>
                        <DataGridPro
                          rowHeight={160}
                          headerHeight={30}
                          disableColumnMenu
                          hideFooterPagination={true}
                          hideFooter={true}
                          rows={firstRows}
                          columns={columns('first')}
                          onRowClick={(params) => {
                            removeFirstRowClickHandler(params, selectedType)
                          }}
                          sx={{
                            '& .MuiDataGrid-cell:focus': {
                              outline: 'none',
                            },
                          }}
                        />
                      </div>
                    </div>
                  )}
                  {step > 1 && (
                    <div className='mt-4'>
                      <label className='text-gray-700 text-[1.25rem] mb-1 block font-semibold'>
                        다음과 같이 변경 됩니다.
                      </label>
                      <div className='h-[205px] py-2'>
                        <DataGridPro
                          rowHeight={160}
                          headerHeight={30}
                          disableColumnMenu
                          hideFooterPagination={true}
                          hideFooter={true}
                          rows={removeResultsRows}
                          columns={columns('result')}
                          sx={{
                            '& .MuiDataGrid-cell:focus': {
                              outline: 'none',
                            },
                          }}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div className={'flex gap-10 py-4 justify-center'}>
            <button
              type='button'
              className='bg-neutral-600 text-white px-6 py-2 rounded-lg hover:bg-neutral-700 transition'
              onClick={closeHandler}
            >
              취소
            </button>
            <button
              type='button'
              className={`${
                buttonTypeHandler(selectedType)
                  ? 'bg-emerald-500 hover:bg-emerald-600'
                  : 'bg-neutral-600'
              } text-white px-6 py-2 rounded-lg  transition`}
              onClick={() => {
                if (buttonTypeHandler(selectedType)) {
                  updateCorrectHandler(selectedType)
                }
              }}
            >
              변경
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}
export default CorrectModal
